
const validateCategoryIds = (rule, value, callback) => {
    if (value.length === 0) {
        callback(new Error('请选择类目'));
    } else {
        callback();
    }
}
const validateTitle = (rule, value, callback, context) => {
    const regx = /^\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]$/;
    if (value.length > 60) {
        callback(new Error('字数不能超过60'))
    } else if (regx.test(value)) {
        callback(new Error('不能含emoj表情'));
    } else {
        callback();
    }
}
const validateImageUrls = async (rule, value, callback, context) => {
    let sum = 0;
    if (value.length) {
        value.forEach(v => {
            if (v) sum++;
        })
    }
    if (value.length < 1 || sum === 0) {
        callback(new Error('至少要选择1张图片'));
    } else if (sum > 9) {
        callback(new Error('图片数量需小于等于9张'));
    } else if (context.$refs.headImgs) {
        let errMsg = await context.$refs.headImgs.method_validImage()
        if (errMsg) {
            callback(new Error(errMsg));
        } else {
            callback();
        }
    } else  {
        callback()
    }
    
}
const validateDetailImageUrls = async (rule, value, callback, context) => {
    let sum = 0;
    if (value.length) {
        value.forEach(v => {
            if (v) sum++;
        })
    }
   if (sum > 20) {
        callback(new Error('图片数量需小于等于20张'));
    } else if (context.$refs.descInfo) {
        let errMsg = await context.$refs.descInfo.method_validImage()
        if (errMsg) {
            callback(new Error(errMsg));
        } else {
            callback();
        }
    } else  {
        callback()
    }
}

// 若需要vm上下文请用此函数包裹
function contextWrap(fn, context) {
    return (rule, value, callback) => fn(rule, value, callback, context)
}

const RULES = function(context) {
    return {
        categoryIds: [
            {required: true, message: '请选择类目'},
            {validator: validateCategoryIds}
        ],
        headImgs: [
            {required: true, message: '至少选择1张图片'},
            {validator: contextWrap(validateImageUrls, context)}
        ],
        title: [
            {required: true, message: '请输入商品名称'},
            {validator: contextWrap(validateTitle, context)},
        ],
        descInfo: [
            {validator: contextWrap(validateDetailImageUrls, context)},
        ],
    };
} 


const validateSkuStock = (value, prop) => {
    value = String(value).trim();
    const valueNum = Number(value);
    const idx = value.lastIndexOf('.');
    const mStr = value.slice(idx+1);
    if (value === '') {
        return prop.label + '不能为空值!'
    } else if (isNaN(valueNum)) {
        return prop.label + '必须为大于等于0的正数';
    } else if (valueNum < 0) {
        return prop.label + '必须为大于等于0的正数';
    } else if (idx !== -1 &&  mStr.length > 0) {
        return prop.label + '必须为大于等于0的正数';
    } else {
        return false;
    }
}

export {
    RULES as default,
    validateSkuStock
}
